import React from "react"
import "./Modal.css"

// function Modal(props) {
//   const { outerId, display, className, dotOnClick, header, children, ...modalProps } = props;
//   return (
//     <div id={outerId} className='modal-container-outer' style={{ display: (display ? "block" : "none") }}>
//       <div className="modal-container-inner">
//         <div
//           {...modalProps}
//           className={"modal-box" + (className ? " " + className : "")}>
//           <div onClick={dotOnClick} className='modal-dot'></div>
//           <h1 className='modal-heading'>{header}</h1>
//           <div className='modal-message overflow-auto'>
//             {children}
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Modal;

import { Modal } from "react-bootstrap"

function ModalComponent(props) {
  const { show, className, onClose, header, children, ...modalProps } = props
  return (
    <Modal
      {...modalProps}
      show={show}
      className="modal-component"
      dialogClassName={className}
      scrollable
      centered
      onHide={onClose}
    >
      <div onClick={onClose} className="modal-dot"></div>

      <Modal.Header>
        <Modal.Title>{header}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
    //   </div>
    // </div>
  )
}

export default ModalComponent
